import { render } from "./AppFooterMember.vue?vue&type=template&id=68436eaa"
import script from "./AppFooterMember.vue?vue&type=script&lang=js"
export * from "./AppFooterMember.vue?vue&type=script&lang=js"

import "./AppFooterMember.vue?vue&type=style&index=0&id=68436eaa&lang=css"

import exportComponent from "C:\\Users\\acer1\\Desktop\\TTT-Member\\Partner\\GOODLUCK711\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__